import { render, staticRenderFns } from "./RegisterQuestions.vue?vue&type=template&id=9463bba4&"
import script from "./RegisterQuestions.vue?vue&type=script&lang=js&"
export * from "./RegisterQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports